import { AddressFieldInternal, componentName } from './AddressFieldInternal';

customElements.define(componentName, AddressFieldInternal);
